/**
 * Environment predicates used to decide which third-party integrations may run.
 *
 * Two predicates rather than one, on purpose: a Cypress run against the test site is not a local
 * run, so the things that must stay real for the specs are keyed on IS_LOCAL while the trackers
 * are keyed on TRACKING_DISABLED.
 *
 * @author Cristian David
 * @since 2026-09-09
 */

/**
 * True only when the page is served from the developer's machine.
 *
 * Derived from the hostname rather than from a build variable so that it holds even when
 * `.env.local` is missing or wrong: a page on localhost can never be mistaken for production.
 */
export const IS_LOCAL = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

/**
 * True when no analytics or error-reporting library may be initialised.
 *
 * Covers three cases: local development, a Cypress run (`window.isCypressTest`, the flag the specs
 * already set and which until now only gated Tag Manager), and an explicit opt-out for a deployed
 * environment. False on test and production, where every integration loads exactly as before.
 */
export const TRACKING_DISABLED =
  IS_LOCAL || window.isCypressTest === true || import.meta.env.VITE_DISABLE_TRACKING === 'true';
